import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReceivingRequestSummaryPage } from './receiving-request-summary.page';

const routes: Routes = [
  {
    path: '',
    component: ReceivingRequestSummaryPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReceivingRequestSummaryPageRoutingModule {}
